// extracted by mini-css-extract-plugin
export default {"live-jobs":"Livejobs_live-jobs__9FIaW","create-job":"Livejobs_create-job__szgNt"};